import React from 'react'
import Layout from '../layout/Layout'
import SettingsSvg from '../other/svg/SettingsSvg'
import View from '../atoms/View'
import { useTranslation } from 'react-i18next'
import SettingsUpdatePassword from '../molecules/SettingsUpdatePassword'

const UpdatePasswordSetting = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Layout
      iconComponent={<SettingsSvg className="w-8 h-8 text-white" />}
      withFiler={false}
      name={t('profile_settings')}>
      <View className="bg-lightGrey shadow-bothSmall rounded-3">
        <SettingsUpdatePassword />
      </View>
    </Layout>
  )
}

export default UpdatePasswordSetting
